class DateTimeUtil {
  static getJoinedHoursMinIntFromTimeStringWithColon = (sInput) => {
    if ( typeof sInput !== 'string' || sInput === null ) return false;

    const aTimeParts = sInput.split(':');
    while ( aTimeParts[0].charAt(0) === '0' )
    {
      aTimeParts[0] = aTimeParts[0].substr(1);
    }

    return parseInt(aTimeParts.join(""));
  };

  // tijd minimaal X minuten in de toekomst
  static getJoinedHoursMinIntForXMinutesFromNow = (iXMinutes) => {
    if ( typeof iXMinutes === 'undefined' ) iXMinutes = 0;

    var oToday = new Date();
    var oNewDate = new Date(oToday.getTime() + iXMinutes * 60000);
    return parseInt(oNewDate.getHours() + '' + oNewDate.getMinutes());
  };

  /**
   * Maak van 900 (9 uur en 0 minuten) 540 (het aantal minuten sinds 0 uur om 9 uur 's morgens)
   * @param iInput
   */
  static getRealMinutesInDayFromJoinedHoursMinInt(iInput)
  {
    if ( typeof iInput !== 'number' ) return false;

    const sInput = iInput + '';
    let iHours, iMinutes;

    switch ( sInput.length )
    {
      case 0:
        return false;
      case 1:
        return iInput;
    }

    // 2 of meer tekens
    iHours = parseInt(sInput.substr(0, (sInput.length - 2)));
    iMinutes = parseInt(sInput.substr(-2, 2));
    return iHours * 60 + iMinutes;
  };

  /**
   * Maak van 540 voor 9 uur 's morgens 900
   * @param iInput
   */
  static getJoinedHoursMinIntFromRealMinutesInDay(iInput)
  {
    if ( typeof iInput !== 'number' ) return false;
    let iHours, sHours, iMinutes, sMinutes;
    iHours = Math.floor(iInput / 60);
    sHours = iHours + '';
    iMinutes = (iInput % 60);
    sMinutes = iMinutes + '';
    if ( sMinutes.length === 1 ) sMinutes = '0' + sMinutes;
    return parseInt(sHours + sMinutes);
  };

  static getTimeObjectsFromTo = (iInputFirstTime, iInputLastTime, iMinutesInterval = false) => {
    // we zijn niet 's nachts open dus we hoeven geen rekening te houden met tijden na middernacht waarbij iLastTime < iFirstTime
    const aTimes = []; // time array
    if ( iInputLastTime < iInputFirstTime || typeof iInputFirstTime !== 'number' || typeof iInputLastTime !== 'number' ) return aTimes;

    const iFirstTime = DateTimeUtil.getRealMinutesInDayFromJoinedHoursMinInt(iInputFirstTime);
    const iLastTime = DateTimeUtil.getRealMinutesInDayFromJoinedHoursMinInt(iInputLastTime);

    let iCurrentTotalMinutes = iFirstTime;

    let iProtection = 0;
    let iHours, sHours, iMinutes, sMinutes, iJoinHoursMinInt;

    while ( iProtection < 1000 && iCurrentTotalMinutes <= iLastTime )
    {
      iHours = Math.floor(iCurrentTotalMinutes / 60);
      sHours = iHours + '';
      iMinutes = (iCurrentTotalMinutes % 60);
      sMinutes = iMinutes + '';
      iJoinHoursMinInt = DateTimeUtil.getJoinedHoursMinIntFromRealMinutesInDay(iCurrentTotalMinutes); // 9 uur 's morgens als 900, niet 540
      aTimes.push({
        iTimeAsJoinedHoursMin: iJoinHoursMinInt, // 9 uur 's morgens is 900 en niet 540 (het aantal minuten vanaf 0 uur) - reden is dat tijd vergelijkingen dan net zo goed werken maar debuggen van blokkades veel makkelijker is
        sTime: DateTimeUtil.getTimeAsStringWithSemicolonFromJoinedHoursMinInt(iJoinHoursMinInt),
        iHours: iHours,
        iMinutes: iMinutes,
        bAvailable: true
      });

      if ( iMinutesInterval === false )
      {
        //Voor 14:00 is het mogelijk per kwartier te boeken
        if ( iJoinHoursMinInt < 1400 )
        {
          iMinutesInterval = 15;
        }
        else
        {
          iMinutesInterval = 30;
        }
      }

      iCurrentTotalMinutes = iCurrentTotalMinutes + iMinutesInterval;
      ++iProtection;
    }

    return aTimes;
  };

  /**
   * Maak van 900 '9:00'
   * @param iMinutes
   */
  static getTimeAsStringWithSemicolonFromJoinedHoursMinInt = (iMinutes) => {
    if ( typeof iMinutes !== 'number' && typeof iMinutes !== 'string' ) return false;
    let sMinutes = iMinutes + '';

    if ( sMinutes.length === 0 )
    {
      return '00:00';
    }
    else if ( sMinutes.length === 1 )
    {
      return '00:0' + sMinutes;
    }
    else if ( sMinutes.length === 2 )
    {
      return '00:' + sMinutes;
    }


    return sMinutes.substr(0, (sMinutes.length - 2)) + ':' + sMinutes.substr(-2);
  };

  static getWeekDayNumber = (sDateDDdashMMdashYYYY) => {
    let sDate = DateTimeUtil.convertDateToYYYYdashMMdashDD(sDateDDdashMMdashYYYY, false);
    const date = new Date(sDate);
    return date.getDay(); // Sunday = 0, Saturday = 6
  }

  static getWeekDayNL = (sDateDDdashMMdashYYYY) => {
    const aInputDateParts = sDateDDdashMMdashYYYY.match(/(\d+)/g);
    let dtInput = new Date(aInputDateParts[2], aInputDateParts[1] - 1, aInputDateParts[0], 23, 59);
    let aDayNames = ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"];
    let iDayNr = dtInput.getDay();

    // zondag = getDay() === 0
    if ( typeof aDayNames[iDayNr] !== 'undefined' )
    {
      return aDayNames[iDayNr];
    }

    return '';
  }

  static getDateNiceNL = (sDateDDdashMMdashYYYY) => {
    const aInputDateParts = sDateDDdashMMdashYYYY.match(/(\d+)/g);
    // Parse the input date
    let dtInput = new Date(aInputDateParts[2], aInputDateParts[1] - 1, aInputDateParts[0], 23, 59);

    // Define days and months in Dutch
    let aDayNames = ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"];
    let aMonthNames = ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"];

    // Get the components of the date
    let iDayNr = dtInput.getDay();
    let sDayName = aDayNames[iDayNr];
    let iDay = dtInput.getDate();
    let sMonthName = aMonthNames[dtInput.getMonth()];
    let iYear = dtInput.getFullYear();

    // Format the date string in Dutch
    return `${sDayName} ${iDay} ${sMonthName}`;
    // return `${sDayName.charAt(0).toUpperCase() + sDayName.slice(1)} ${iDay} ${sMonthName} ${iYear}`;
  };

  static isDateInPast = (sDateDDdashMMdashYYYY) => {
    // console.log('isDateInPast: ', sDateDDdashMMdashYYYY);
    let dtNow = new Date();
    const aInputDateParts = sDateDDdashMMdashYYYY.match(/(\d+)/g);
    let dtInput = new Date(aInputDateParts[2], aInputDateParts[1] - 1, aInputDateParts[0], 23, 59);
    let bResult = dtNow > dtInput;

    // console.log('Debug: de geteste date is ', sDateDDdashMMdashYYYY, ' wat als date is: ', dtInput, ' isDateInPast:', bResult);
    return bResult;
  }

  //Geeft een array met alle dagen die tussen de start en einddatum liggen
  static getDaysFromRange = (sStartDate, sEndDate) => //d-m-yyyy
  {
    const range_date_off = [sStartDate, sEndDate];
    const d1 = parseDate(range_date_off[0]);
    const d2 = parseDate(range_date_off[1]);

    let days = [];
    for ( let dt = d1; dt <= d2; dt.setDate(dt.getDate() + 1) )
    {
      const fdt = new Date(dt);
      days.push(fdt.getDate() + "-" + (fdt.getMonth() + 1) + "-" + fdt.getFullYear());
    }

    function parseDate(input)
    {
      const parts = input.match(/(\d+)/g);
      return new Date(parts[2], parts[1] - 1, parts[0]);
    }

    return days; //d-m-yyyy
  };

  static convertDateToYYYYdashMMdashDD = (sInputDate, bUseLeadingZeros = false) => {
    let day, month, year;

    // Match different possible formats
    const match = sInputDate.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$|^(\d{1,2})-(\d{1,2})-(\d{4})$/);

    if ( !match )
    {
      throw new Error("Invalid date format");
    }

    if ( match[1] )
    {
      // Format: YYYY-M-D or YYYY-MM-DD
      year = parseInt(match[1], 10);
      month = parseInt(match[2], 10);
      day = parseInt(match[3], 10);
    }
    else
    {
      // Format: D-M-YYYY or DD-MM-YYYY
      day = parseInt(match[4], 10);
      month = parseInt(match[5], 10);
      year = parseInt(match[6], 10);
    }

    // Apply leading zeroes if needed
    if ( bUseLeadingZeros )
    {
      month = month.toString().padStart(2, '0');
      day = day.toString().padStart(2, '0');
    }

    return `${year}-${month}-${day}`;
  };

  static convertDateToDDdashMMdashYYYY = (sInputDate, bUseLeadingZeros = false) => {
    // Normalize delimiters and split the date
    let aParts = sInputDate.split('-').map(part => parseInt(part, 10));

    let day, month, year;

    // Detect format based on the number of digits in each part
    if ( aParts[0] > 31 )
    { // Year first format (YYYY-MM-DD or YYYY-M-D)
      [year, month, day] = aParts;
    }
    else
    { // Day first format (DD-MM-YYYY or D-M-YYYY)
      [day, month, year] = aParts;
    }

    // Apply leading zeros if required
    if ( bUseLeadingZeros )
    {
      day = String(day).padStart(2, '0');
      month = String(month).padStart(2, '0');
    }

    return `${day}-${month}-${year}`;
  };


  // DE OUDE VERSIE (wordt nog gebruikt... prima.. maar de nieuwe zijn veelzijdiger en cool als komkommer)
  static convertYYYYdashMMdashDDToDDdashMMdashYYYY = (sInputYYYYMMDD, bRemoveLeadingZeros = false) => {
    if ( typeof sInputYYYYMMDD !== 'string' ) return false;

    const aDateParts = sInputYYYYMMDD.split('-');
    if ( aDateParts.length !== 3 ) return false;
    if ( aDateParts[2].length === 4 ) return sInputYYYYMMDD; // was al goed
    if ( aDateParts[0].length !== 4 ) return false; // onduidelijk wat dit dan is...

    // let oDate = new Date(aDateParts[0], aDateParts[1] - 1, aDateParts[2]); // maanden zijn in Date van 0-11

    if ( bRemoveLeadingZeros )
    {
      while ( aDateParts[0].charAt(0) === '0' )
      {
        aDateParts[0] = aDateParts[0].substr(1);
      }

      while ( aDateParts[1].charAt(0) === '0' )
      {
        aDateParts[1] = aDateParts[1].substr(1);
      }

      while ( aDateParts[2].charAt(0) === '0' )
      {
        aDateParts[2] = aDateParts[2].substr(1);
      }
    }

    return aDateParts[2] + '-' + aDateParts[1] + '-' + aDateParts[0];
  };

  static getDateFromString = (sDate, iHours, iMinutes) => //dd-mm-yyyy
  {
    if ( typeof sDate !== 'string' || sDate === null ) return false;

    if ( typeof iHours === "undefined" || iHours === false )
    { // als niets is opgegeven dan nemen we 2 uur 's nachts - dat is ook veilig bij zomertijd/wintertijd e.d.
      iHours = 2;
    }

    if ( typeof iMinutes === "undefined" || iMinutes === false )
    {
      iMinutes = 0;
    }

    sDate = sDate.split('-');

    return new Date(sDate[2], sDate[1] - 1, sDate[0], iHours, iMinutes);
  };

  static getDateFromParts = (iDay, iMonthNormal, iYear) => {
    return new Date(iYear, iMonthNormal - 1, iDay);
  };

  static getStringFromDate = (oDate) => {
    let d = oDate.getDate();
    d = d + '';
    if ( d.length === 1 ) d = '0' + d;

    let m = oDate.getMonth();
    m += 1;  // JavaScript months are 0-11
    m = m + '';

    if ( m.length === 1 ) m = '0' + m;
    const y = oDate.getFullYear();

    return d + "-" + m + "-" + y;
  };

  static getTodayAsString = () => {
    const oToday = new Date();
    return DateTimeUtil.getStringFromDate(oToday);
  };

  static getMondayInSeptember = () => {
    const sCurrentYear = (new Date()).getFullYear();
    const dDayInSeptember = new Date(sCurrentYear, 8, 9); // maanden beginnen bij 0
    // console.log(dDayInSeptember);
    return DateTimeUtil.getMondayInSameWeek(dDayInSeptember);
  };

  static getMondayInSameWeek = (d) => {
    d = new Date(d);
    let day = d.getDay();
    let diff = d.getDate() - day + (day === 0 ? -6 : 1);
    return new Date(d.setDate(diff));
  };

  static removeLeadingZeros = (sDate) => //dd-mm-yyyy
  {
    if ( typeof sDate === 'undefined' || sDate === false ) return false;

    let aDateParts = sDate.split('-');

    while ( aDateParts[0].charAt(0) === '0' )
    {
      aDateParts[0] = aDateParts[0].substr(1);
    }

    while ( aDateParts[1].charAt(0) === '0' )
    {
      aDateParts[1] = aDateParts[1].substr(1);
    }

    return aDateParts[0] + '-' + aDateParts[1] + '-' + aDateParts[2];
  }
}

// aanvullingen op het JS date object
//Datum utils
Date.prototype.isSunday = function () {
  return this.getDay() === 0;
};

Date.prototype.isMonday = function () {
  return this.getDay() === 1;
};

Date.prototype.isTuesday = function () {
  return this.getDay() === 2;
};

Date.prototype.isWednesday = function () {
  return this.getDay() === 3;
};

Date.prototype.isThursday = function () {
  return this.getDay() === 4;
};

Date.prototype.isFriday = function () {
  return this.getDay() === 5;
};

Date.prototype.isSaturday = function () {
  return this.getDay() === 6;
};

Date.prototype.isWeekend = function () {
  return this.getDay() === 0 || this.getDay() === 6;
};

Date.prototype.isFriSatSun = function () {
  return this.getDay() === 0 || this.getDay() === 5 || this.getDay() === 6;
};

Date.prototype.isWithinXHours = function (iHours) {
  if ( typeof iHours === "undefined" )
  {
    iHours = 0;
  }

  var oToday = new Date();
  var oNewDate = new Date(oToday.getTime() + iHours * 60 * 60000);
  console.log('isWithingXHours oNewDate:', oNewDate, this < oNewDate);

  return this < oNewDate;
};

// Kijk of het de eerst,tweede,derde,vierde dag van de maand is
Date.prototype.inFirstWeekOfMonth = function () {
  return this.getDate() <= 7;
};
Date.prototype.inSecondWeekOfMonth = function () {
  return Math.ceil(this.getDate() / 7) === 2;
};
Date.prototype.inThirdWeekOfMonth = function () {
  return Math.ceil(this.getDate() / 7) === 3;
};
Date.prototype.inLastWeekOfMonth = function () {
  return this.getDate() > this.lastDayOfMonth() - 7;
};

// De laatste dag van de maand als date
Date.prototype.lastDayOfMonth = function () {
  return new Date(this.getFullYear(), this.getMonth() + 1, 0).getDate();
};

// nog te porten: ShopViewDateTime
// 		function processBlocks()
// 		{
// 			hmkbook.tb.v.ShopViewDateTime.reloadAvailableTimeslots();
// 			//resetten van kalender en feedback
// 			jQuery('.bookDate .js-date-feedback, .bookDateTimeHotel .js-date-feedback').text('');
// 			hmkbook.tb.v.ShopViewDateTime.reloadDayDescriptionForCurrentDate();
// 			hmkbook.tb.v.ShopView.oDatepickerDaysConfig = {};
//
// 			var voOrder = _prxOrder.getOrderVO();
// 			var oRelevantBlockObjects = _prxBlocker.getRelevantBlockObjects(); // Haalt alle blokkades op die relevant zijn voor de huidige situatie
// 			var CurrentOrderDate = false;
//
// 			if (voOrder.isDateValid())
// 			{
// 				CurrentOrderDate = Hmk.removeLeadingZeros(voOrder.getDate());
// 			}
//
// 			if (oRelevantBlockObjects)
// 			{
// 				var bSelectedDateIsBlocked = false;
// 				_.each(oRelevantBlockObjects, function (oBlockObject)
// 				{
// 					if (oBlockObject.FromTime == hmkbook.base.utils.Global.iDefaultOpeningTime && oBlockObject.ToTime == hmkbook.base.utils.Global.iDefaultClosingTime)
// 					{
// 						hmkbook.tb.v.ShopViewDateTime.writeDayAsBlockedDate(oBlockObject.Date);
//
// 						if (CurrentOrderDate == oBlockObject.Date)
// 						{
// 							// Iemand probeert te boeken met een datum die heel de dag geblokkeerd is
// 							// in de huidige situatie. Hier moet melding van gemaakt worden en de kalender
// 							// moet getoond worden zodat de bezoeker een andere datum kan kiezen. Dit doen we
// 							// aan het einde van de loop zodat eventuele andere blokkades ook worden getoond
// 							// bij de kalender refresh
// 							bSelectedDateIsBlocked = true;
// 							if (voOrder.getTreatmentType() == 'se' ) hmkbook.tb.v.ShopViewDateTime.checkMainEntreeBlock(oBlockObject);
// 						}
// 					}
// 				});
//
// 				//if (voOrder.getTreatmentType() == 'se' && CurrentOrderDate)
// 				//{
// 				//	var aBlockedMainEntreeIDs = _prxBlocker.getBlockedMainEntreesBlockForWholeDay();
// 				//	console.log(aBlockedMainEntreeIDs);
// 				//	if(aBlockedMainEntreeIDs)
// 				//	{
// 				//		_.each(aBlockedMainEntreeIDs, function (iMainEntreeID)
// 				//		{
// 				//				jQuery("#input_reservation_type_entree_" + iMainEntreeID).prop("disabled", true);
// 				//		});
// 				//	}
// 				//}
//
// 				if (bSelectedDateIsBlocked)
// 				{
// 					hmkbook.tb.v.ShopViewDateTime.processSelectedDateIsBlocked();
// 				}
// 				hmkbook.tb.v.ShopViewUiUtils.initAdvancedDatepicker();
// 			}
// 		}
// 		parent.processBlocks = processBlocks;
//
// 		function checkMainEntreeBlock(oBlockObject)
// 		{
// 			if (typeof oBlockObject === 'undefined') return false;
//
//
// 			_.each( hmkbook.base.utils.Global.aNonActieEntreeExternalIDs , function (iMainEntreeID)
// 			{
//
// 				if (oBlockObject.ProductIDs.indexOf(iMainEntreeID) >= 0)
// 				{
// 					jQuery("#input_reservation_type_entree_" + iMainEntreeID).prop("disabled", true);
// 				}
// 				else
// 				{
// 					jQuery("#input_reservation_type_entree_" + iMainEntreeID).prop("disabled", false);
// 				}
// 			});
// 		}
// 		parent.checkMainEntreeBlock = checkMainEntreeBlock;
//
// 		function isReservationDateToday()
// 		{
// 			var oCurrentOrderVO = _prxOrder.getOrderVO();
// 			if (oCurrentOrderVO.isDateValid())
// 			{
// 				var oStartDate = Hmk.getDateFromString(oCurrentOrderVO.getDate()).getTime();
// 				var oToday = new Date();
// 				oToday = oToday.setHours(0, 0, 0, 0);
// 				if (oStartDate == oToday)
// 				{
// 					return true
// 				}
// 				return false;
// 			}
// 		}
// 		parent.isReservationDateToday = isReservationDateToday;
//
// 		function getArrivalTimeXMinutesFromNow(XMinutes)
// 		{
// 			//Aankomsttijd minimaal X minuten in de toekomst
// 			var oToday = new Date();
// 			var oNewDate = new Date(oToday.getTime() + XMinutes * 60000);
// 			return parseInt(oNewDate.getHours() + '' + oNewDate.getMinutes());
// 		}
// 		parent.getArrivalTimeXMinutesFromNow = getArrivalTimeXMinutesFromNow;
//
// 		function reloadAvailableTimeslots() //Aanroepen bij init en zodra de datum wordt gewijzigd
// 		{
// 			var oCurrentOrderVO = _prxOrder.getOrderVO();
//
// 			// opvragen huidige entree type
// 			var voSelectedOrderedEntryProduct = oCurrentOrderVO.getSelectedEntryProduct();
// 			var sStartTimeSelectedEntryProduct = '09:00';
// 			var sEndTimeSelectedEntryProductTemp = '23:00';
// 			var iEndTimeSelectedEntryProduct = '2300';
//
// 			if(oCurrentOrderVO.getTreatmentID() == 1261) // Vroegevogel arrangement
// 			{
// 					sEndTimeSelectedEntryProductTemp = '10:00';
// 					iEndTimeSelectedEntryProduct = Hmk.getTimeWithoutColon(sEndTimeSelectedEntryProductTemp);
// 			}
//
// 			if (voSelectedOrderedEntryProduct != false)
// 			{
// 				var voSelectedEntryProduct = voSelectedOrderedEntryProduct.getProductVOFromCatalogue();
// 				sStartTimeSelectedEntryProduct = voSelectedEntryProduct.getDefaultTime();
//
// 				switch (voSelectedEntryProduct.getID())
// 				{
// 					case 2: // ochtend
// 						iEndTimeSelectedEntryProduct = hmkbook.base.utils.Global.iDefaultEntreeOchtendClosingTime;
// 						break;
// 				}
// 			}
//
// 			var iStartTimeSelectedEntryProduct = Hmk.getTimeWithoutColon(sStartTimeSelectedEntryProduct);
// 			var iFromTime = iStartTimeSelectedEntryProduct;
// 			var iToTime = iEndTimeSelectedEntryProduct;
//
// 			if (iFromTime === 0) iFromTime = hmkbook.base.utils.Global.iDefaultOpeningTime;
//
// 			hmkbook.tb.v.ShopViewDateTime.adjustOptionsToThisTimeslot(hmkbook.tb.v.ShopView.inputFieldStartTime, iFromTime, iToTime, 1);
//
// 			if (oCurrentOrderVO.isDateValid())
// 			{
// 				if (hmkbook.tb.v.ShopViewDateTime.isReservationDateToday())
// 				{
// 					var iTimeFromNow = hmkbook.tb.v.ShopViewDateTime.getArrivalTimeXMinutesFromNow(30);
// 					if (iFromTime < iTimeFromNow) iFromTime = iTimeFromNow;
// 					hmkbook.tb.v.ShopViewDateTime.adjustOptionsToThisTimeslot(hmkbook.tb.v.ShopView.inputFieldStartTime, iFromTime, iToTime, 1);
// 				}
//
// 				var oCurrentOrder = _prxOrder.getOrderVO();
// 				var sTreatmentType = oCurrentOrder.getTreatmentType();
// 				var iTreatmentID = oCurrentOrder.getTreatmentID();
//
// 				var oBlockItems = {};
//
// 				var aAllMainTreatmentIDs = [];
// 				if( sTreatmentType == 'se')
// 				{ // het kan zijn dat 1 persoon een actie entree heeft en samen komt met extra personen op normale entrees
// 					var aPeople = oCurrentOrderVO.getAllPeople();
// 					_.each(aPeople, function (voPerson)
// 					{
// 						var oMainOrderedProductForPerson = voPerson.getMainOrderedProduct();
// 						if( typeof oMainOrderedProductForPerson != 'undefined' && oMainOrderedProductForPerson != false)
// 						{
// 							var id = oMainOrderedProductForPerson.getProductVOFromCatalogue().getID();
// 							if( aAllMainTreatmentIDs.indexOf( id ) == -1 ) aAllMainTreatmentIDs.push( id );
// 						}
// 					});
//
// 					_.each(aAllMainTreatmentIDs, function (iTreatmentID)
// 					{
// 						var aBlocksForTreatmentType = _prxBlocker.getBlocksForTreatmentType(iTreatmentID, oCurrentOrderVO.getDate(), iFromTime);
//
// 						_.each(aBlocksForTreatmentType, function(oBlockItem, sKey)
// 						{
// 							oBlockItems[sKey] = oBlockItem;
// 						});
//
// 					});
// 				}
// 				else
// 				{ // bij arrangementen heeft iedereen altijd hetzelfde
// 					oBlockItems = _prxBlocker.getBlocksForTreatmentType(iTreatmentID, oCurrentOrderVO.getDate(), iFromTime);
// 				}
//
// 				if (oBlockItems)
// 				{
// 					_.each(oBlockItems, function(oBlockedItem)
// 					{
// 						//if (iFromTime < oBlockItem.FromTime)
// 						iFromTime = oBlockedItem.FromTime;
// 						//if (iToTime > oBlockItem.ToTime)
// 						iToTime = oBlockedItem.ToTime;
//
// 						if (sTreatmentType == 'se' && typeof voSelectedEntryProduct !== 'undefined')
// 						{
// 							//Blokkade tijden vermengen met de entreetijden
// 							if( hmkbook.base.utils.Global.aEntreeOchtendExternalIDs.indexOf( voSelectedEntryProduct.getID() ) > -1 )
// 							{	// ochtend
// 								if (iStartTimeSelectedEntryProduct > iFromTime) iFromTime = iStartTimeSelectedEntryProduct;
// 								if (iEndTimeSelectedEntryProduct < iToTime) iToTime = hmkbook.base.utils.Global.iDefaultClosingTime; // 2400
// 							}
// 							else if( hmkbook.base.utils.Global.aEntreeAvondExternalIDs.indexOf( voSelectedEntryProduct.getID() ) > -1)
// 							{ // avond
// 								if (iStartTimeSelectedEntryProduct > iFromTime) iFromTime = hmkbook.base.utils.Global.iDefaultOpeningTime;
// 								if (iToTime < iStartTimeSelectedEntryProduct) iToTime = iStartTimeSelectedEntryProduct;
// 								if (iEndTimeSelectedEntryProduct < iToTime) iToTime = iEndTimeSelectedEntryProduct;
// 							}
// 						}
//
// 						hmkbook.tb.v.ShopViewDateTime.adjustOptionsToThisTimeslot(hmkbook.tb.v.ShopView.inputFieldStartTime, iFromTime, iToTime, 0, false);
// 					});
// 				}
// 			}
// 		}
// 		parent.reloadAvailableTimeslots = reloadAvailableTimeslots;
//
// 		function resetTimeSelector(oInput)
// 		{
// 			var sOptionTime, iOptionTime;
// 			jQuery(oInput).find('option').each(function (idx, elem)
// 			{
// 				if (idx != 0)
// 				{
// 					sOptionTime = jQuery(this).attr("value");
// 					iOptionTime = Hmk.getTimeWithoutColon(sOptionTime);
// 					jQuery(this).removeAttr('disabled').text(sOptionTime); //reset
// 				}
// 			});
// 		}
// 		parent.resetTimeSelector = resetTimeSelector;
//
// 		// input in format 900 voor 9 uur 's ochtends
// 		function adjustOptionsToThisTimeslot(oInput, iArrival, iDeparture, bType, bReset, bAddNotAvailableText) //bType 0=blokken, 1=enkel beschikbaar maken
// 		{
// 			if (typeof bAddNotAvailableText === 'undefined') bAddNotAvailableText = true;
// 			if (typeof bType === 'undefined') return false;
// 			if (typeof bReset === 'undefined') bReset = true;
// 			var sOptionTime, iOptionTime;
//
// 			jQuery(oInput).find('option').each(function (idx, elem)
// 			{
// 				if (idx != 0)
// 				{
// 					sOptionTime = jQuery(this).attr("value");
// 					iOptionTime = Hmk.getTimeWithoutColon(sOptionTime);
// 					if (bReset)
// 					{
// 						jQuery(this).removeAttr('disabled').text(sOptionTime); //reset
// 					}
// 					switch (bType)
// 					{
// 						case 0:
// 							if (iOptionTime >= iArrival && iOptionTime <= iDeparture)
// 							{
// 								disableSelectOption(this, bAddNotAvailableText);
// 							}
// 							break;
// 						case 1:
// 							if (iOptionTime < iArrival || iOptionTime > iDeparture)
// 							{
// 								disableSelectOption(this, bAddNotAvailableText);
// 							}
// 							break;
// 					}
//
// 				}
// 			});
// 				// inline
// 				function disableSelectOption(oInput, bAddNotAvailableText)
// 				{
// 					if (bAddNotAvailableText == true)
// 					{
// 						jQuery(oInput).attr('disabled', 'disabled').text(sOptionTime + '  ' + Hmk._t('DATE_LEGEND_NOT_AVAILABLE'));
// 					}
// 					else
// 					{
// 						jQuery(oInput).attr('disabled', 'disabled');
// 					}
// 				}
//
// 				var oCurrentOrderVO = _prxOrder.getOrderVO();
// 				// als starttijd of vertrekttijd nu niet (meer) is ingesteld dan de dropdown resetten naar -kies-
// 			// als we dat niet zouden doen dan zou het in sommige gevallen kunnen lijken alsof er wel een datum is geselecteerd
// 			if (jQuery(oInput).hasClass('js-time-arrival') == true && oCurrentOrderVO.isStartTimeValid() == false)
// 			{
// 				jQuery(oInput).val('');
// 			}
//
// 			if (jQuery(oInput).hasClass('js-time-depart') == true && oCurrentOrderVO.isEndTimeValid() == false)
// 			{
// 				jQuery(oInput).val('');
// 			}
//
// 			// als de geselecteerde tijd nu niet meer beschikbaar is dan moet dat naar de datalaag door worden gegeven
// 			// Mits er al een tijd is ingesteld
//
// 			if (oCurrentOrderVO.getStartTime() !== false)
// 			{
// 				if (jQuery(oInput).hasClass('js-time-depart') == false)
// 				{ // alleen voor starttijd
//
// 					hmkbook.tb.v.ShopViewDateTime.processStartTime(jQuery(oInput).first());
// 				}
// 			}
// 		}
// 		parent.adjustOptionsToThisTimeslot = adjustOptionsToThisTimeslot;
//
// 		function processStartTime(jqInput)
// 		{
// 			var sTime = jqInput.val();
// 			var voOrder = _prxOrder.getOrderVO();
//
// 			// Uitgezet omdat deeplinked arr direct worden verwijderd nadat ze zijn toegevoegd als je de datum aanpast. (13-11-2015)
// 			//
// 			switch (voOrder.getTreatmentType())
// 			{
// 				case 'sa':
// 				case 'ha':
// 					voOrder.removeAllOrderedArrangements();
// 					break;
// 			}
//
// 			if (typeof sTime !== 'undefined') voOrder.setStartTime(sTime);
// 			_prxOrder.fireEverythingChangedEvent();
//
// 			if (voOrder.getStartTime() !== false)
// 			{
// 				if (voOrder.getTreatmentType() == 'ha')
// 				{
// 					var timeFeedback = jQuery('.bookDateTimeHotel .js-time-feedback');
// 					timeFeedback.text('');
// 					if(Hmk.getTimeWithoutColon(voOrder.getStartTime()) < 1400)
// 					{
// 						timeFeedback.text(Hmk._t('HOTEL_CHECKIN_NOTICE'));
// 					}
//
// 					if (voOrder.getEndTime() !== false)
// 					{
// 						hmkbook.tb.v.ShopView.loadArrangementListIfAllowed();
// 					}
// 				}
// 				else
// 				{
// 					hmkbook.tb.v.ShopView.loadArrangementListIfAllowed();
// 				}
// 			}
// 			else
// 			{
// 				jQuery(hmkbook.tb.v.ShopView.inputFieldStartTime).find('option[value=""]').attr('selected', 'selected');
// 				jQuery('.bookArrangement').addClass('bookHidden');
// 			}
//
// 			hmkbook.tb.v.ShopViewUiUtils.resetPrevNextLinks();
// 		}
// 		parent.processStartTime = processStartTime;
//
//
// 		function processEndTime(jqInput)
// 		{
// 			var sTime = jqInput.val();
// 			var voOrder = _prxOrder.getOrderVO();
// 			var aCurrentStepConfig = hmkbook.tb.v.ShopView.getStepConfig(hmkbook.tb.v.ShopView.getCurrentStepID());
// 			// Uitgezet omdat deeplinked arr direct worden verwijderd nadat ze zijn toegevoegd als je de datum aanpast. (13-11-2015)
// 			//
// 			switch (voOrder.getTreatmentType())
// 			{
// 				case 'sa':
// 				case 'ha':
// 					if (aCurrentStepConfig['id'] == 10)
// 					{
// 						voOrder.removeAllOrderedArrangements();
// 					}
// 					break;
// 			}
//
// 			if (voOrder.isEndTimeValid(sTime))
// 			{
// 				voOrder.setEndTime(sTime);
// 			}
// 			else
// 			{
// 				voOrder.setEndTime(null);
// 			}
//
// 			_prxOrder.fireEverythingChangedEvent();
//
// 			if (voOrder.getTreatmentType() == 'ha' && voOrder.isEndTimeValid())
// 			{
// 				if (voOrder.isEndDateValid())
// 				{
// 					hmkbook.tb.v.ShopView.loadArrangementListIfAllowed();
// 				}
// 			}
// 			else
// 			{
// 				jQuery(hmkbook.tb.v.ShopView.inputFieldEndTime).find('option[value=""]').attr('selected', 'selected');
// 				jQuery('.bookArrangement').addClass('bookHidden');
// 			}
// 			hmkbook.tb.v.ShopViewUiUtils.resetPrevNextLinks();
// 		}
// 		parent.processEndTime = processEndTime;
//
// 		function processSelectedDateIsBlocked()
// 		{
// 			var voOrder = _prxOrder.getOrderVO();
// 			jQuery('.bookDate .js-date-feedback, .bookDateTimeHotel .js-date-feedback').text(': ' + voOrder.getDate() + ' ' + Hmk._t('DATE_NOT_AVAILABLE'));
// 			hmkbook.tb.v.ShopViewDateTime.reloadDayDescriptionForCurrentDate();
// 			hmkbook.tb.v.ShopViewDateTime.setStartDate(null);
//
// 			switch (voOrder.getTreatmentType())
// 			{
// 				case 'se':
// 				case 'sa':
// 					jQuery('.bookDate').removeClass('bookHidden');
// 					jQuery('.bookArrivalTimeExact .js-calendar-description').addClass('bookHidden');
// 					break;
// 				case 'ha':
// 					jQuery('.bookDateTimeHotel').removeClass('bookHidden');
// 					break;
// 			}
// 		}
// 		parent.processSelectedDateIsBlocked = processSelectedDateIsBlocked;
//
// 		function writeDayAsBlockedDate(sDate) //dd-m-yyyy
// 		{
// 			if (typeof sDate === 'undefined') return false;
// 			var aDateParts = sDate.split('-');
// 			var sDay = aDateParts[0];
// 			var sMonth = aDateParts[1];
// 			while (sMonth.charAt(0) === '0')
// 			{
// 				sMonth = sMonth.substr(1);
// 			}
// 			var sYear = aDateParts[2];
//
// 			if (typeof hmkbook.tb.v.ShopView.oDatepickerDaysConfig[sYear] === 'undefined') hmkbook.tb.v.ShopView.oDatepickerDaysConfig[sYear] = {};
// 			if (typeof hmkbook.tb.v.ShopView.oDatepickerDaysConfig[sYear][sMonth] === 'undefined') hmkbook.tb.v.ShopView.oDatepickerDaysConfig[sYear][sMonth] = {};
// 			if (typeof hmkbook.tb.v.ShopView.oDatepickerDaysConfig[sYear][sMonth][sDay] === 'undefined') hmkbook.tb.v.ShopView.oDatepickerDaysConfig[sYear][sMonth][sDay] = {};
// 			hmkbook.tb.v.ShopView.oDatepickerDaysConfig[sYear][sMonth][sDay].available = 0;
// 		}
// 		parent.writeDayAsBlockedDate = writeDayAsBlockedDate;
//
// 		function prefillEndDate()
// 		{
// 			var oCurrentOrderVO = _prxOrder.getOrderVO();
// 			if (oCurrentOrderVO.isTreatmentTypeValid() && oCurrentOrderVO.getTreatmentType() == 'ha' && oCurrentOrderVO.isDateValid())
// 			{
// 				//Bij hotel, startdatum? -> Einddatum prefillen op 1 dag na aankomst
// 				var oEndDate = Hmk.getDateFromString(oCurrentOrderVO.getDate());
// 				oEndDate.setDate(oEndDate.getDate() + 1); //Gast moet minimaal 1 nacht boeken
// 				hmkbook.tb.v.ShopViewDateTime.setEndDate(Hmk.getStringFromDate(oEndDate));
// 			}
// 		}
// 		parent.prefillEndDate = prefillEndDate;
//
// 		function setStartDate(sInput)
// 		{
// 			var voOrder = _prxOrder.getOrderVO();
//
// 			// Uitgezet omdat deeplinked arr direct worden verwijderd nadat ze zijn toegevoegd als je de datum aanpast. (13-11-2015)
// 			//
// 			switch (voOrder.getTreatmentType())
// 			{
// 				case 'sa':
// 				case 'ha':
// 					voOrder.removeAllOrderedArrangements();
// 					break;
// 			}
//
// 			voOrder.setDate(sInput);
//
// 			_prxOrder.fireEverythingChangedEvent();
//
// 			if (voOrder.getDate() !== false)
// 			{
// 			//	processBlocks();
// 				hmkbook.tb.v.ShopViewDateTime.reloadDayDescriptionForCurrentDate();
// 				hmkbook.tb.v.ShopViewDateTime.reloadAvailableTimeslots();
// 			}
//
// 			if (voOrder.getTreatmentType() == 'ha' && voOrder.isEndDateValid() == false)
// 			{
// 				voOrder.setEndDate(null);
// 			}
//
// 			if (voOrder.getDate() !== false && voOrder.getStartTime() !== false && voOrder.getTreatmentType() !== 'se')
// 			{
// 				hmkbook.tb.v.ShopView.loadArrangementListIfAllowed();
// 			}
// 			else
// 			{
// 				jQuery('.bookArrangement').addClass('bookHidden');
// 			}
//
// 			hmkbook.tb.v.ShopViewUiUtils.resetPrevNextLinks();
// 		}
// 		parent.setStartDate = setStartDate;
//
// 		function setEndDate(sInput)
// 		{
// 			var voOrder = _prxOrder.getOrderVO();
//
// 			// Uitgezet omdat deeplinked arr direct worden verwijderd nadat ze zijn toegevoegd als je de datum aanpast. (13-11-2015)
// 			//
// 			switch (voOrder.getTreatmentType())
// 			{
// 				case 'sa':
// 				case 'ha':
// 					voOrder.removeAllOrderedArrangements();
// 					break;
// 			}
// 			if (voOrder.isEndDateValid(sInput))
// 			{
// 				voOrder.setEndDate(sInput);
// 			}
// 			_prxOrder.fireEverythingChangedEvent();
// 			if (voOrder.isEndDateValid())
// 			{
// 				hmkbook.tb.v.ShopViewDateTime.reloadAvailableTimeslots();
// 			}
//
// 			if (voOrder.isEndDateValid())
// 			{
// 				hmkbook.tb.v.ShopView.loadArrangementListIfAllowed();
// 			}
// 			else
// 			{
// 				jQuery('.bookArrangement').addClass('bookHidden');
// 			}
//
// 			hmkbook.tb.v.ShopViewUiUtils.resetPrevNextLinks();
// 		}
// 		parent.setEndDate = setEndDate;
//
// 		function reloadDayDescriptionForCurrentDate()
// 		{
// 			var voOrder = _prxOrder.getOrderVO();
// 			var sDate = Hmk.removeLeadingZeros(voOrder.getDate());
// 			var sBlockedDayDescription = '';
// 			var sSpecialDayDescription = '';
//
// 			if (typeof sDate === 'undefined' || sDate === false)
// 			{
// 				sBlockedDayDescription = '';
// 				sSpecialDayDescription = '';
// 			}
// 			else
// 			{
// 				var aBlockItems = _prxBlocker.getBlocksForTreatmentType(voOrder.getTreatmentID(), sDate);
//
// 				_.each(aBlockItems, function (oBlockItem)
// 				{
// 					if (typeof oBlockItem.Content === 'undefined') return;
// 					sBlockedDayDescription += oBlockItem.Content;
//
// 					if(oBlockItem.ShowAltBtn && oBlockItem.AltLink && oBlockItem.BtnLabel){
// 						sBlockedDayDescription += '<a href="' + oBlockItem.AltLink + '" class="btn btnArrow">' + oBlockItem.BtnLabel + '</a>';
// 					}
//
// 					sBlockedDayDescription += '<br/><br/>';
//
// 				});
//
// 				var voCat = _prxCatalogue.getCatalogueVO();
// 				var oSpecialDayInfo = voCat.getSpecialDayInfoForDate(sDate);
// 				if (oSpecialDayInfo == false)
// 				{
// 					sSpecialDayDescription = '';
// 				}
// 				else
// 				{
// 					sSpecialDayDescription = oSpecialDayInfo.Description;
// 				}
// 			}
//
// 			jQuery('.js-calendar-description p.blockedDayDesc').html(sBlockedDayDescription);
// 			jQuery('.js-calendar-description p.specialDayDesc').html(sSpecialDayDescription);
// 		}
// 		parent.reloadDayDescriptionForCurrentDate = reloadDayDescriptionForCurrentDate;

export default DateTimeUtil;